import React from "react";
import PropTypes from "prop-types";
import Third from "../icons/third.png";
import ThirdBlue from "../icons/third-blue.png";

const ProfessionalDetailStepIcon = ({ show, completed }) => {
  const iconSrc = completed || show ? Third : ThirdBlue;

  return (
    <div className="WH32">
      <img src={iconSrc} alt="Professional Step Icon" />
    </div>
  );
};



ProfessionalDetailStepIcon.propTypes = {
  completed: PropTypes.any,
  show: PropTypes.bool,
};

export default ProfessionalDetailStepIcon;
